import axios from 'axios'
import store from '@/store'
import User from '@/connection/user'

export default {

  async validateVoucher (code) {
    try {
      let sessionToken = await User.getSessionToken('session_token')
      if (sessionToken) {
        let header = { 'Authorization': sessionToken}
        let result = await axios.get(store.getters.getPromotionsApi + '/voucher/validate?company_id=' + store.getters.getCompanyId + '&code=' + code, {headers: header})
        if (result.data) {
          return result.data
        } else {
          return {error: true, code: 500, msg:'Erro ao obter voucher'}
        }
      } else {
        return {error: true, code: 400, msg:'Sessão Expirada.'}
      }
    } catch (e) {
      console.log(e)
      return {error: true, msg: e}
    }
  }

}
